import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import el from './locales/el.json';
import en from './locales/en.json';

const STORAGE_KEY = 'shmatch:landing:locale';

export type LandingLocale = 'el' | 'en';

function getStoredLocale(): LandingLocale {
  if (typeof window === 'undefined') return 'el';
  const stored = window.localStorage.getItem(STORAGE_KEY);
  if (stored === 'en' || stored === 'el') return stored;
  return 'el';
}

function getInitialLocale(): LandingLocale {
  if (typeof window !== 'undefined') {
    const params = new URLSearchParams(window.location.search);
    const lang = params.get('lang');
    if (lang === 'en' || lang === 'el') {
      return lang;
    }
  }
  return getStoredLocale();
}

void i18n.use(initReactI18next).init({
  resources: {
    el: { translation: el },
    en: { translation: en },
  },
  lng: getInitialLocale(),
  fallbackLng: 'el',
  interpolation: { escapeValue: false },
});

export function setLandingLocale(lang: LandingLocale): void {
  void i18n.changeLanguage(lang);
  try {
    window.localStorage.setItem(STORAGE_KEY, lang);
    document.documentElement.lang = lang;
    document.documentElement.setAttribute('dir', 'ltr');
  } catch {
    /* ignore */
  }
}

document.documentElement.lang = i18n.language || 'el';

export default i18n;
